// extracted by mini-css-extract-plugin
export var actions = "_kd-g";
export var benefitCard = "_kd-b";
export var benefitIcon = "_kd-d";
export var benefitLabel = "_kd-f";
export var benefits = "_kd-a";
export var benefitsSection = "_kd-8";
export var bodyText = "_kd-7";
export var closeButton = "_kd-2";
export var content = "_kd-3";
export var eyebrow = "_kd-4";
export var heading = "_kd-5";
export var image = "_kd-i";
export var imagePanel = "_kd-h";
export var modal = "_kd-0";
export var offerCard = "_kd-c";
export var offerIcon = "_kd-e";
export var sectionLabel = "_kd-9";
export var shell = "_kd-1";
export var title = "_kd-6";